import { FormHeader, FormHeaderActions } from './FormHeader';
import { AritoFormV2 } from '@/components/custom/erp';
import { ConfirmDialog } from '../../components';
import type { FormDialogProps } from './types';
import { useFormDialog } from './hooks';
import { FormTabs } from './FormTabs';
import BottomBar from './BottomBar';

const FormDialog = (props: FormDialogProps) => {
  const dialog = useFormDialog(props);
  const { tong_thue, tong_tien, tong_chiet_khau, tong_thanh_toan } = dialog.totals;

  return (
    <>
      <AritoFormV2
        mode={dialog.formMode}
        initialData={dialog.initialValues}
        title={dialog.title}
        schema={dialog.schema}
        actionButtons={dialog.actionButtons}
        subTitle='Hóa đơn mua dịch vụ'
        onSubmit={dialog.submit}
        onClose={dialog.onClose}
        headerFields={FormHeader(dialog)}
        headerTabActions={<FormHeaderActions dialog={dialog} />}
        tabs={FormTabs(dialog)}
        bottomBar={
          dialog.activeTab === 'info' ? (
            <BottomBar
              tong_tien={tong_tien}
              tong_thue={tong_thue}
              tong_chiet_khau={tong_chiet_khau}
              tong_thanh_toan={tong_thanh_toan}
              state={dialog.formState.state}
            />
          ) : null
        }
      />

      {dialog.taxConfirm.open ? (
        <ConfirmDialog
          open={dialog.taxConfirm.open}
          onClose={dialog.taxConfirm.close}
          onConfirm={dialog.taxConfirm.confirm}
          title='Xác nhận phân bổ thuế'
          content='Bạn có muốn phân bổ lại tiền thuế cho các mặt hàng ở chi tiết không?'
        />
      ) : null}
    </>
  );
};

export default FormDialog;
